export const environment = {
  production: false,
  sso_url:"",
  print_url: "https://dq.netseven.work/",
  api_key: "",
  codeToToken_url: "",
  sectormain_printlength: 5500,
};
